.character {
  font-size: 24px;
  font-family: var(--font-family-branded);
  color: var(--colors-grays-black);
  background-color: var(--colors-grays-white);
  border-radius: var(--border-radius-sm);
  border: 0 none;
  outline: 1px solid var(--colors-grays-light);
}

.characterError {
  font-size: 24px;
  font-family: var(--font-family-branded);
  color: var(--colors-grays-black);
  background-color: var(--colors-grays-white);
  border-radius: var(--border-radius-sm);
  border: 0 none;
  outline: 1px solid var(--colors-system-negative-main);
}

.characterSelected {
  outline: 2px solid var(--colors-primary-main);
}

.characterSelectedError {
  outline: 2px solid var(--colors-system-negative-main);
}

.buttonGroup {
  flex-direction: column-reverse;

  @media (--reefer-media-tablet-min) {
    flex-direction: row;
  }
}
